import Konva from "konva"

const GetRelativePosition = (
    dataWrapper: Konva.Layer,
    elem?: Konva.Node,
) => {
    const stage = dataWrapper.getStage()
    const scale = stage.scaleX()

    const dataPos = dataWrapper.absolutePosition()
    const elemPos = elem
        ? elem.absolutePosition()
        : stage.getPointerPosition()

    const position = {
        x: (elemPos.x - dataPos.x) / scale,
        y: (elemPos.y - dataPos.y) / scale,
    }
    return position
}
export default GetRelativePosition
